import { Box, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { IBlockedDisplayName, IBlockedWord } from '../../../services/types';
import KeywordManagement from '../../keyword/KeywordManagement';
import {
  getBlockedWords,
  addBlockedWord,
  deleteBlockedWord,
  getBlockedDisplayNames,
  addBlockedDisplayName,
  deleteBlockedDisplayName,
} from '../../../services/api/Moderation';

interface IProps {}

const useStyles = makeStyles(() => ({
  paper: {
    width: 918,
    padding: '22px 20px 24px',
    marginBottom: 20,
  },
}));

const BlockedWordSettings = (props: IProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Box>
      <Paper className={classes.paper}>
        <KeywordManagement<IBlockedWord>
          title="Blocked Words"
          description="Blocked words will be redacted from comments when shown to users."
          fetchFactory={getBlockedWords}
          saveFactory={addBlockedWord}
          deleteFactory={deleteBlockedWord}
        />
      </Paper>

      <Paper className={classes.paper}>
        <KeywordManagement<IBlockedDisplayName>
          title="Blocked Display Names"
          description="Users cannot use or include names that are listed as blocked names as/in their display names. 
        Please add names that you believe can cause confusion or be offensive to other users to this list."
          fetchFactory={getBlockedDisplayNames}
          saveFactory={addBlockedDisplayName}
          deleteFactory={deleteBlockedDisplayName}
        />
      </Paper>
    </Box>
  );
};

export default BlockedWordSettings;
